/**
 * Класс для управления аккордеоном меню.
 * Реализует логику: при открытии одного пункта, остальные закрываются.
 */
export class Accordion {
    constructor(options = {}) {
        // Названия классов без точек (для формирования модификаторов --active)
        this.parentClass = options.parentClass || 'menu-accordion__parent';
        this.subMenuClass = options.subMenuClass || 'sub-menu';

        this.initialized = false;
    }

    init() {
        if (this.initialized) return;

        // Ищем все родительские элементы
        this.parents = Array.from(document.getElementsByClassName(this.parentClass));

        if (this.parents.length === 0) return;

        this.bindEvents();
        this.initialized = true;
    }

    bindEvents() {
        this.parents.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggle(item);
            });
        });
    }

    toggle(clickedItem) {
        const panel = clickedItem.nextElementSibling;

        // Проверяем, открыта ли панель сейчас
        const isOpen = panel && panel.style.maxHeight;

        // 1. Сначала закрываем ВСЕ открытые панели
        this.parents.forEach((parent) => {
            parent.classList.remove(`${this.parentClass}--active`);
            const subMenu = parent.nextElementSibling;
            if (subMenu) {
                subMenu.style.maxHeight = null;
                subMenu.classList.remove(`${this.subMenuClass}--active`);
            }
        });

        // 2. Если кликнутая панель была закрыта — открываем её
        if (!isOpen && panel) {
            clickedItem.classList.add(`${this.parentClass}--active`);
            panel.classList.add(`${this.subMenuClass}--active`);
            // scrollHeight позволяет плавно анимировать высоту от 0 до авто
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }
}